import { Component, Input, ViewChild } from '@angular/core';
import {
  ObservationDefinition,
  ObservationDefinitionInterval,
} from 'app/mdm/lib/observation-definition/observation-definition';
import { EditableFlexTableComponent } from '@heda/core-hospital-ui';

@Component({
  selector: 'hw-observation-definition-intervals-table',
  templateUrl: 'observation-definition-intervals-table.component.html',
  styles: [
    `
      .form-row {
        padding: 0 20px;
      }
    `,
  ],
})
export class ObservationDefinitionIntervalsTableComponent {
  @Input() public editMode: boolean = true;
  @Input() public definition: ObservationDefinition;
  @ViewChild('intervalsTable') public intervalsTable: EditableFlexTableComponent<ObservationDefinitionInterval>;

  public defaultIntervalRow: ObservationDefinitionInterval = {
    usage: {
      code: 'default',
    },
    criteria: {},
  };

  public validate(): boolean {
    return this.intervalsTable.validate();
  }

  public duplicateInterval(rowIndex: number): void {
    const source = this.definition.intervals[rowIndex];
    const copy: ObservationDefinitionInterval = JSON.parse(JSON.stringify({ ...source, id: undefined }));
    this.intervalsTable.addRow(copy, true);
  }
}
